"use client";

import React from "react";
import { Box } from "@mui/material";
import Kicker from "@/src/components/common/broadsheet/kicker";

const StyledDivider = ({ label }: { icon?: React.ElementType; label: string }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      mt: 1,
      mb: 0.375,
    }}
  >
    <Kicker component="span" sx={{ whiteSpace: "nowrap" }}>
      {label}
    </Kicker>
    <Box
      aria-hidden="true"
      sx={{
        flex: 1,
        height: 0,
        borderTop: "1px solid",
        borderColor: "custom.ruleHairline",
      }}
    />
  </Box>
);

export default StyledDivider;
